<template>
  <Table :config="config" :data="users">
    <template #filter>
      <SearchFilter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
        <!-- <label class="block text-gray-700">Role:</label>
        <select v-model="form.role" class="form-select mt-1 w-full">
          <option :value="null" />
          <option value="user">User</option>
          <option value="owner">Owner</option>
        </select>
        <label class="block mt-4 text-gray-700">Trashed:</label>
        <select v-model="form.trashed" class="form-select mt-1 w-full">
          <option :value="null" />
          <option value="with">With Trashed</option>
          <option value="only">Only Trashed</option>
        </select> -->
      </SearchFilter>
    </template>
  </Table>
</template>

<script setup>
import pickBy from "lodash/pickBy";
import debounce from "lodash/debounce";
import SearchFilter from "@/Shared/SearchFilter";
import { reactive, watch } from "vue";
import { Inertia } from "@inertiajs/inertia";
import Table from "@/Shared/Table.vue";
let props = defineProps({
  filters: Object,
  users: Object,
});

let form = reactive({
  search: props.filters.search,
  role: props.filters.role,
  trashed: props.filters.trashed,
});

const config = reactive({
  title: "warga",
  print: "print-barcode",
  table: [
    {
      title: "Full Name",
      field: "name",
    },
    {
      title: "Nomor Rumah",
      field: "house_number",
    },
  ],
});

watch(
  form,
  debounce(function (value) {
    Inertia.get("/warga", value, { preserveState: true });
  }, 300)
);

function reset() {
  form.search = null;
  form.role = null;
  form.trashed = null;
}
</script>
